import { Injectable, inject, signal } from '@angular/core';
import {
  AutomatedTransferCustomerNotificationConfigResponse,
  NOTIFICATION_CONFIG_KEYS,
  NotificationSettings,
} from '../../../../../pages/administration/contract/customer-notifications.contract';
import { CustomersApiService } from '../../../../../pages/administration/services/customers-api.service';
import { Authorities } from '../../../../../shared/enums/authorities.enum';
import { Modules } from '../../../../../shared/enums/modules.enum';
import { AuthService } from '../../../../services/auth.service';

@Injectable({ providedIn: 'root' })
export class CanSeeAutomatedTransfersOverlayService {
  private authService = inject(AuthService);
  private customerApiService = inject(CustomersApiService);

  $canSee = signal<boolean>(false);

  readonly canFetchAutomatedTransfersNotifications =
    this.authService.hasAnyAuthority([
      Authorities.AUTOMATED_TRANSFERS_CONFIGURATION_MANAGEMENT,
      Authorities.CUSTOMER_UPDATE,
    ]) && this.authService.hasModule(Modules.AUTOMATED_TRANSFERS);

  setVisibility(): void {
    const customerId = this.authService.userCustomerId;
    if (this.canFetchAutomatedTransfersNotifications) {
      this.customerApiService.getAutomatedTransfersCustomerNotificationConfig(customerId).subscribe((res) => {
        this.$canSee.set(this.isAnyATSettingEnabled(res));
      });
    }
  }

  private isAnyATSettingEnabled(res: AutomatedTransferCustomerNotificationConfigResponse) {
    for (const key of NOTIFICATION_CONFIG_KEYS) {
      const settingsKey = res[key] as NotificationSettings;
      if (settingsKey && settingsKey.enabled) {
        return true;
      }
    }
    return false;
  }
}
